export const GET_ASSESSMENTS_SUCCEED = 'Trainer/GET_ASSESSMENTS_SUCCEED';
export const GET_ASSESSMENTS_ERROR = 'Trainer/GET_ASSESSMENTS_ERROR';
export const GET_ASSESSMENT_SUCCEED = 'Trainer/GET_ASSESSMENT_SUCCEED';
export const GET_ASSESSMENT_ERROR = 'Trainer/GET_ASSESSMENT_ERROR';

export const CREATE_ASSESSMENT_SUCCEEDED =
  'Trainer/CREATE_ASSESSMENT_SUCCEEDED';
export const CREATE_ASSESSMENT_ERROR = 'Trainer/CREATE_ASSESSMENT_ERROR';

export const UPDATE_ASSESSMENT_SUCCEEDED =
  'Trainer/UPDATE_ASSESSMENT_SUCCEEDED';
export const UPDATE_ASSESSMENT_ERROR = 'Trainer/UPDATE_ASSESSMENT_ERROR';
export const LOADING_STATE = 'Assessment/LOADING_STATE';
